import script from "./MultipleChoiceOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./MultipleChoiceOptions.vue?vue&type=script&setup=true&lang=js"

import "./MultipleChoiceOptions.vue?vue&type=style&index=0&id=3bb90b8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb90b8d"]])

export default __exports__